//Apollo
import ApolloClient from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';

import {createUploadLink} from 'apollo-upload-client';
import {urls, urlsLog} from '../config/keys';

const linkApp = createUploadLink({uri: urls.graph, credentials: 'include'});
const linkLog = createUploadLink({uri: urlsLog.graph, credentials: 'include'});

const defaultOptions = {
   watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
   },
   query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
   }
};

export const clientApp = new ApolloClient({
   cache: new InMemoryCache(),
   link: linkApp,
   defaultOptions
});

export const clientLog = new ApolloClient({
   cache: new InMemoryCache(),
   link: linkLog,
   defaultOptions
});
